/* ============================================================
   MXBOLTS THEME JS
   ============================================================ */
(function(){
  'use strict';

  /* ----- Mobile menu ----- */
  const menuBtn = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.nav');
  if(menuBtn && nav){
    menuBtn.addEventListener('click',()=>{
      nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', nav.classList.contains('open'));
    });
    nav.querySelectorAll('.nav-item > button').forEach(b=>{
      b.addEventListener('click',e=>{
        if(window.innerWidth <= 980){
          e.preventDefault();
          b.parentElement.classList.toggle('open');
        }
      });
    });
  }

  /* ----- Header hide on scroll down, show on scroll up ----- */
  var lastScroll = 0;
  var header = document.querySelector('.site-header');
  var brandbar = document.querySelector('.brandbar');
  var scrollThreshold = 80;
  window.addEventListener('scroll', function(){
    var currentScroll = window.pageYOffset;
    if(currentScroll <= scrollThreshold){
      // At top — always show
      if(header) header.classList.remove('is-hidden');
      return;
    }
    if(currentScroll > lastScroll){
      // Scrolling DOWN — hide
      if(header) header.classList.add('is-hidden');
    } else {
      // Scrolling UP — show
      if(header) header.classList.remove('is-hidden');
    }
    lastScroll = currentScroll;
  }, {passive:true});

  /* ----- Reveal on scroll ----- */
  const revealEls = document.querySelectorAll('.reveal');
  if('IntersectionObserver' in window && revealEls.length){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{
        if(e.isIntersecting){
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    },{threshold:.12});
    revealEls.forEach(el=>io.observe(el));
  }

  /* ----- Cart Drawer ----- */
  const drawer = document.querySelector('.cart-drawer');
  const overlay = document.querySelector('.cart-overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartClose = document.querySelectorAll('[data-cart-close]');

  function openCart(){
    if(!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow='hidden';
    window.mxOpenCart = openCart;
  }
  function closeCart(){
    if(!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow='';
  }
  cartTriggers.forEach(t=>t.addEventListener('click',e=>{e.preventDefault();openCart();refreshCart();}));
  cartClose.forEach(t=>t.addEventListener('click',closeCart));
  overlay && overlay.addEventListener('click',closeCart);
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart();});

  /* ----- Cart fetch + render ----- */
  async function refreshCart(){
    try{
      const r = await fetch('/cart.js');
      const cart = await r.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    }catch(e){console.error(e);}
  }

  function updateCartCount(n){
    document.querySelectorAll('[data-cart-count]').forEach(el=>{
      el.textContent = n;
      el.setAttribute('data-count', n);
      if(el.classList.contains('stickycart__count')){
        // sticky uses CSS [data-count="0"] to hide
      } else {
        el.style.display = n > 0 ? 'grid' : 'none';
      }
    });
  }

  function money(cents){
    const v = (cents/100).toFixed(2);
    return '$' + v;
  }

  function renderCart(cart){
    window.mxRenderCart = renderCart;
    const list = document.querySelector('[data-cart-items]');
    const total = document.querySelector('[data-cart-total]');
    const foot = document.getElementById('cart-foot');
    const emptyState = document.getElementById('cart-empty-state');
    if(!list) return;

    if(cart.items.length === 0){
      list.innerHTML = '';
      list.style.display = 'none';
      if(emptyState) emptyState.style.display = 'flex';
      if(foot) foot.style.display = 'none';
      var ymal = document.getElementById('cart-ymal');
      if(ymal) ymal.style.display = 'none';
      if(total) total.textContent = '$0.00';
      return;
    }

    list.style.display = '';
    if(emptyState) emptyState.style.display = 'none';
    if(foot) foot.style.display = '';

    // Show you may also like
    var ymal = document.getElementById('cart-ymal');
    if(ymal){ ymal.style.display = ''; if(window.loadYmal) window.loadYmal(); }

    list.innerHTML = cart.items.map(item=>`
      <div class="cart-line" data-key="${item.key}">
        <div class="cart-line__img"><img src="${item.image ? item.image.replace(/(\.[^.]+)$/, '_400x$1') : ''}" alt="${item.title}"></div>
        <div>
          <div class="cart-line__title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title}</div>` : ''}
          <div class="cart-line__qty-row">
            <div class="cart-line__qty">
              <button data-qty-down>−</button>
              <span>${item.quantity}</span>
              <button data-qty-up>+</button>
            </div>
            <button class="cart-line__remove" data-remove aria-label="Remove item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" style="width:15px;height:15px"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg></button>
          </div>
        </div>
        <div class="cart-line__price">${money(item.line_price)}</div>
      </div>
    `).join('');

    if(total) total.textContent = money(cart.total_price);

    // ---- free-shipping progress bar (US, $30 threshold) ----
    var shipEl = document.querySelector('[data-cart-ship]');
    if(shipEl){
      var threshold = parseInt(shipEl.dataset.threshold || '3000', 10); // cents
      var totalCents = cart.total_price; // Shopify cart total_price is in cents
      var msgEl = shipEl.querySelector('[data-cart-ship-msg]');
      var amtEl = shipEl.querySelector('[data-cart-ship-amt]');
      var fillEl = shipEl.querySelector('[data-cart-ship-fill]');
      var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
      if(totalCents >= threshold){
        shipEl.classList.add('is-unlocked');
        if(msgEl) msgEl.textContent = "🎉 You've unlocked FREE US shipping!";
        if(amtEl) amtEl.textContent = '';
        if(fillEl) fillEl.style.width = '100%';
      } else {
        shipEl.classList.remove('is-unlocked');
        var remaining = threshold - totalCents;
        if(msgEl) msgEl.textContent = 'Add ' + money(remaining) + ' more for FREE US shipping';
        if(amtEl) amtEl.textContent = money(totalCents) + ' / ' + money(threshold);
        if(fillEl) fillEl.style.width = pct + '%';
      }
    }

    // attach handlers
    list.querySelectorAll('.cart-line').forEach(line=>{
      const key = line.dataset.key;
      const item = cart.items.find(i=>i.key===key);
      line.querySelector('[data-qty-down]').addEventListener('click',()=>updateLine(key, item.quantity-1));
      line.querySelector('[data-qty-up]').addEventListener('click',()=>updateLine(key, item.quantity+1));
      line.querySelector('[data-remove]').addEventListener('click',()=>{
        const priceEl = line.querySelector('.cart-line__price');
        if(priceEl) priceEl.innerHTML = '<span class="cart-line__spinner"></span>';
        updateLine(key, 0);
      });
    });
  }

  async function updateLine(key, qty){
    try{
      const r = await fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:key, quantity:qty})
      });
      const cart = await r.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    }catch(e){console.error(e);}
  }

  /* ----- Add to cart (PDP & quick) ----- */
  document.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
    let buyNowClicked = false;
    const buyNowBtn = form.querySelector('[data-buy-now]');
    if(buyNowBtn){
      buyNowBtn.addEventListener('click',()=>{ buyNowClicked = true; });
    }
    form.addEventListener('submit',async e=>{
      // Explicit HTML5 validation (preventDefault below bypasses native browser validation)
      if(!form.checkValidity()){
        form.reportValidity();
        return;
      }
      // Buy Now: skip ajax, add then redirect to checkout
      if(buyNowClicked){
        e.preventDefault();
        const fd = new FormData(form);
        try{
          await fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});
          window.location.href = '/checkout';
        }catch(err){ window.location.href = '/cart'; }
        return;
      }
      e.preventDefault();
      const btn = form.querySelector('[type=submit]:not([data-buy-now])');
      const orig = btn ? btn.textContent : '';
      if(btn){btn.disabled=true; btn.textContent='Adding…';}
      const fd = new FormData(form);
      try{
        const r = await fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});
        if(!r.ok) throw new Error('add failed');
        await refreshCart();
        openCart();
        if(btn){btn.textContent='Added ✓'; setTimeout(()=>{btn.textContent=orig; btn.disabled=false;},1200);}
      }catch(err){
        if(btn){btn.textContent='Try again'; btn.disabled=false;}
        console.error(err);
      }
    });
  });

  /* ----- PDP Shop Pay checkout ----- */
  (function(){
    var shopBtn = document.getElementById('pdp-shop-checkout');
    if(!shopBtn) return;
    shopBtn.addEventListener('click', function(e){
      e.preventDefault();
      var form = document.querySelector('.pdp__form');
      var vid = form ? (form.querySelector('input[name="id"]').value || shopBtn.dataset.vid) : shopBtn.dataset.vid;
      var qty = form ? (form.querySelector('input[name="quantity"]').value || 1) : 1;
      if(vid) window.location.href = '/cart/'+vid+':'+qty+'?payment=shop_pay';
    });
  })();

  /* ----- PDP gallery ----- */
  const thumbs = document.querySelectorAll('.pdp__thumb');
  const mainImg = document.querySelector('.pdp__main img');
  thumbs.forEach(t=>{
    t.addEventListener('click',()=>{
      thumbs.forEach(x=>x.classList.remove('is-active'));
      t.classList.add('is-active');
      if(mainImg){
        const newSrc = t.querySelector('img').src.replace(/_(\d+)x(\d+)?\./, '_1200x.');
        mainImg.src = newSrc;
      }
    });
  });

  /* ----- PDP variant select ----- */
  (function(){
    var form = document.querySelector('.pdp__form');
    if(!form) return;
    form.querySelectorAll('.pdp__opt-values').forEach(function(group){
      group.querySelectorAll('.pdp__opt-val').forEach(function(btn){
        btn.addEventListener('click', function(){
          group.querySelectorAll('.pdp__opt-val').forEach(function(x){ x.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          try {
            var el = document.getElementById('pdp-variants-json');
            if(!el) return;
            var variants = JSON.parse(el.textContent);
            var opts = [];
            form.querySelectorAll('.pdp__opt-values').forEach(function(g){
              var s = g.querySelector('.pdp__opt-val.is-selected');
              if(s) opts.push(s.dataset.optValue);
            });
            var match = null;
            for(var i=0;i<variants.length;i++){
              var v = variants[i];
              var ok = true;
              for(var j=0;j<opts.length;j++){
                if(String(v.options[j]) !== String(opts[j])){ ok=false; break; }
              }
              if(ok){ match=v; break; }
            }
            if(!match) return;
            var inp = form.querySelector('input[name="id"]');
            if(inp) inp.value = match.id;
            var addBtn = form.querySelector('[type="submit"]:not([name="checkout"])');
            if(addBtn){
              addBtn.disabled = !match.available;
              addBtn.textContent = match.available ? ('Add to Cart · $'+(match.price/100).toFixed(2)) : 'Sold Out';
            }
            var now = document.querySelector('.pdp__price .now');
            if(now) now.textContent = '$'+(match.price/100).toFixed(2);

            // ---- X3 custom-color conditional box ----
            // Show + require the Custom Color input when the selected value
            // contains "Custom Color" (case-insensitive). Hide + disable otherwise.
            var x3Box = form.querySelector('[data-x3-custom]');
            var x3Input = form.querySelector('[data-x3-input]');
            if(x3Box && x3Input){
              var isCustom = opts.some(function(o){
                return String(o).toLowerCase().indexOf('custom color') !== -1;
              });
              if(isCustom){
                x3Box.hidden = false;
                x3Input.disabled = false;
                x3Input.required = true;
              } else {
                x3Box.hidden = true;
                x3Input.disabled = true;
                x3Input.required = false;
                x3Input.value = '';
              }
            }
          } catch(e){}
        });
      });
    });

    // Initial sync on page load (in case a variant is preselected)
    (function initX3(){
      var x3Box = form.querySelector('[data-x3-custom]');
      var x3Input = form.querySelector('[data-x3-input]');
      if(!x3Box || !x3Input) return;
      var opts = [];
      form.querySelectorAll('.pdp__opt-values').forEach(function(g){
        var s = g.querySelector('.pdp__opt-val.is-selected');
        if(s) opts.push(s.dataset.optValue);
      });
      var isCustom = opts.some(function(o){
        return String(o).toLowerCase().indexOf('custom color') !== -1;
      });
      if(isCustom){
        x3Box.hidden = false;
        x3Input.disabled = false;
        x3Input.required = true;
      }
    })();
  })();

  /* ----- PDP qty ----- */
  document.querySelectorAll('.pdp__qty').forEach(q=>{
    const input = q.querySelector('input');
    q.querySelector('[data-qty-down]').addEventListener('click',()=>{input.value = Math.max(1, parseInt(input.value)-1);});
    q.querySelector('[data-qty-up]').addEventListener('click',()=>{input.value = parseInt(input.value)+1;});
  });

  /* ----- Initial cart count load ----- */
  refreshCart();

  /* ----- Expose ----- */
  window.MX = { openCart, closeCart, refreshCart };
})();
